class LoadMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }
  handleClick() {
    const nextPageLink = this.dataset.nextPage;

    fetch(nextPageLink)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const productGrid = document.querySelector('reveal-items product-list.product-list');
        const newProducts = doc.querySelector('reveal-items product-list.product-list').innerHTML;
        productGrid.insertAdjacentHTML('beforeend', newProducts);

        const newLoadMore = doc.querySelector('.collection__pagination load-more');
        if (newLoadMore) {
          this.dataset.nextPage = newLoadMore.dataset.nextPage;
          this.classList.remove('hidden');
        } else {
          this.classList.add('hidden');
        }
      })
      .catch((error) => {
        this.addEventListener('click', this.handleClick);
        console.error('Error loading more products:', error);
      });
  }
}
customElements.define('load-more', LoadMore);
class CollectionTopBarMobile extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.mainSection = document.querySelector('.shopify-section--main-collection');
    this.filterDrawer = document.querySelector('facet-drawer');
    this.sortDropdown = this.querySelector('.sort-by-dropdown');
    this.sortSelect = this.sortDropdown?.querySelector('.mobile-sort-by-selection');
    this.sortOptions = this.sortSelect?.querySelectorAll('option');

    this.initFiltersHeadingClick();
    this.hideSortByFilters();
    this.initSortDropdownToggle();
    this.initSortChangeHandler();
  }

  initFiltersHeadingClick() {
    this.querySelector('.filters-heading')?.addEventListener('click', () => {
      this.mainSection?.querySelector('facet-floating-filter button')?.click();
    });
  }

  hideSortByFilters() {
    if (!this.filterDrawer) return;

    const filterDetails = this.filterDrawer.querySelectorAll('form details');
    filterDetails.forEach((detail) => {
      const isSortBy = detail.dataset.info?.includes('sort-by');
      detail.classList.toggle('tw-hidden', isSortBy);
    });
  }

  initSortDropdownToggle() {
    const header = this.sortDropdown?.querySelector('.sort-by-dropdown-header');
    const optionsContainer = this.sortDropdown?.querySelector('.sort-by-dropdown-options');

    if (!header || !optionsContainer) return;

    header.addEventListener('click', (e) => {
      e.stopPropagation();
      optionsContainer.classList.toggle('tw-hidden');
      this.sortDropdown.classList.toggle('active');
    });

    optionsContainer.querySelectorAll('.sorting-option').forEach((option) => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        this.selectSortOption(option.dataset.value);
        optionsContainer.classList.add('tw-hidden');
        this.sortDropdown.classList.remove('active');
      });
    });

    document.addEventListener('click', (e) => {
      if (!this.sortDropdown.contains(e.target)) {
        optionsContainer.classList.add('tw-hidden');
        this.sortDropdown.classList.remove('active');
      }
    });
  }

  selectSortOption(value) {
    this.sortOptions?.forEach((option) => {
      if (option.value === value) {
        option.selected = true;
        this.sortSelect.dispatchEvent(new Event('change'));
      }
    });
  }

  initSortChangeHandler() {
    this.sortSelect?.addEventListener('change', () => {
      const selectedValue = this.sortSelect.value;

      this.triggerFilterUpdate(selectedValue);
    });
  }

  triggerFilterUpdate(selectedValue) {
    this.mainSection?.querySelector('facet-floating-filter button')?.click();

    if (!this.filterDrawer) return;

    const filterDetails = this.filterDrawer.querySelectorAll('form details');
    filterDetails.forEach((detail) => {
      detail.querySelectorAll('.checkbox-container').forEach((container) => {
        const input = container.querySelector('input');
        const label = container.querySelector('label');

        if (input?.name === 'sort_by' && input.value === selectedValue) {
          label?.click();
          this.filterDrawer.querySelector('.overlay')?.click();
        }
      });
    });

    this.mainSection?.querySelector('facet-floating-filter button')?.click();
  }
}

customElements.define('collection-top-bar-mobile', CollectionTopBarMobile);
